<template>
  <div>
    <div class="container-fluid">
      <div class="row row-eq-height">
        <div class="col-sm-6 grey-grad-bg"><br>
          <div class="row full-height">
            <div class="col-md-10 col-md-offset-1 text-center full-height flex-v-center">
              <h1 class="">ITEMS ENTERED</h1>
              <div class="choose-color text-left">
                <div class="invoice-details">
                  <p>Invoice/Receipt#: {{ invoiceData.receiptNumber }}</p>
                  <p>Date of Purchase: {{ formatDate(invoiceData.dateOfPurchase) }}</p>
                </div>

                <table id="invoice-items" cellspacing="0" cellpadding="0">
                  <thead>
                    <tr>
                      <th class="col-md-8">Name</th>
                      <th class="col-md-4">Quantity</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item) in invoiceData.items" :key="item.item.id"
                      class="no-hover grey-outline"
                      @click.prevent="goItemDetails(item)"
                      >
                      <td>{{ item.item.name }}</td>
                      <td>{{ item.quantity }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p class="text-center">
                If you have another invoice/receipt to submit please click on “Earn Points” to enter your additional submission.
              </p>
              <br>
            </div>
          </div>
        </div>

        <div class="col-sm-6 redeem-sec">
          <div class="row">
            <div class="col-md-8 col-md-offset-2 text-center pad-top">
              <img src="../../../assets/images/rewards/waiting-for-email.jpg" class="img-responsive">
              <p>Please allow up to 72 business hours for a submission to be reviewed. If approved, Points will be added to your Account Balance. If denied, you will receive an email notifying you of the reason for the denial.</p>
            </div>
            <br>
            <br>
            <br>
          </div>
        </div>
      </div>
    </div><!-- container-fluid -->
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import moment from 'moment'
import axios from 'axios'
axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')

export default {
  name: 'ItemConfirmation',
  props: {
    item: {},
    invoiceData: {}
  },
  data () {
    return {
      receiptData: {
        dateOfPurchase: '',
        receiptNumber: '',
        quantity: 0
      }
    }
  },
  computed: {
    ...mapGetters('loyaltyProgram', ['program']),
    ...mapState('auth', ['user'])
  },
  methods: {
    ...mapActions('receipt', [ 'finishReceipt' ]),
    formatDate (date) {
      return moment(date).format('MM/DD/YYYY').toString()
    },
    goHome () {
      this.$router.push({ name: 'ClientDashboard' })
    }
  }
}
</script>

<style scoped>
.no-hover:hover {
  cursor: initial;
  background-color: initial;
  color: initial;
}

.choose-color {
  padding: 15px;
  margin-bottom: 15px;
}

.invoice-details {
  display: flex;
  justify-content: space-around;
  padding: 0 55px;
}

.flex-v-center {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.full-height {
  height: 100%;
}

table#invoice-items {
  width: 100%;
  max-width: 100%;
  max-height: 225px;

  table-layout: fixed;
  margin-bottom: 20px;
  border-spacing: 10px;
  color: black;
}

table#invoice-items tbody {
  background-color: white;
}

table#invoice-items td, table#invoice-items th {
  padding: 15px 30px;
}

table#invoice-items tr:hover td {
  background-color: transparent; /* or #000 */
}
</style>
